module.exports = __webpack_public_path__ + "img/qypyk-banner.b52929c9.jpg";